import { Home } from "lucide-react";
import PhotoFrame from "./PhotoFrame";

export default function Introduction({ image }) {
  return (
    <section id="house" className="py-24 md:py-32 bg-[#F7F5F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-7 reveal">
            <div className="text-[11px] uppercase tracking-[0.35em] text-[#985F47] mb-5">A welcome</div>
            <h2 className="serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tightest text-[#2C392F] font-light">
              Come home to space, stillness <span className="italic text-[#985F47]">and unhurried days.</span>
            </h2>

            <div className="mt-10 space-y-6 text-[#4A4D4A] text-base md:text-lg leading-relaxed max-w-2xl">
              <p>
                ChiMano House is designed for guests who want more than a room. Set within a very large
                private compound, the house offers the comfort and independence of a home, along with the
                ease of a fully serviced stay.
              </p>
              <p>
                Spend your mornings walking through the orchard, sit among flowering plants, enjoy freshly
                cooked meals or simply find your favourite corner in the open grounds. Whether you are
                visiting Dehradun for a weekend, a family break or a longer stay, ChiMano House gives you
                the space to settle in.
              </p>
            </div>

            <div className="mt-10 flex items-center gap-4 text-[13px] text-[#2C392F]">
              <span className="leaf-divider">Settle in, slow down</span>
            </div>
          </div>

          <div className="lg:col-span-5 reveal">
            <PhotoFrame
              image={image}
              placeholderLabel="Verandah, afternoon"
              placeholderCaption="Single-storey home · Open compound"
              placeholderIcon={Home}
              ratio="aspect-[4/5]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
